export const authKeys = {
  partner: ['auth', 'partner'] as const,
} as const
